var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholderUploadLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M0 0h140v140H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92 88H48c-1.1 0-2-.9-2-2V54c0-1.1.9-2 2-2h44c1.1 0 2 .9 2 2v32c0 1.1-.9 2-2 2zM68.28 73.573l-3.415-3.521-9.635 10.947h30.12L74.565 64.644l-6.284 8.928zm-5.361-9.05a3.791 3.791 0 1 0-7.583.001 3.791 3.791 0 0 0 7.583 0z",
    fill: "#C2C2C2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderUploadLogo);
export default __webpack_public_path__ + "static/media/placeholder-uploadLogo.543470b1.svg";
export { ForwardRef as ReactComponent };